import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';

declare global {
  interface Window {
    Genesys?: any;
    _genesysJs?: string;
  }
}

export const GenesysSupportCenter = () => {
  const { lang, t } = useLanguage();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);

    const initGenesys = () => {
      try {
        if (!window.Genesys) {
          window._genesysJs = 'Genesys';
          window.Genesys = function () {
            (window.Genesys.q = window.Genesys.q || []).push(arguments);
          };
          window.Genesys.t = 1 * Number(new Date());
        }

        window.Genesys.c = {
          environment: t.environment,
          deploymentId: t.deploymentId
        };

        const handleReady = () => {
          if (isMounted) {
            setIsLoading(false);
          }
        };

        window.Genesys('subscribe', 'Launcher.ready', handleReady);
        window.Genesys('subscribe', 'SupportCenter.ready', handleReady);

        let script = document.getElementById('genesys-bootstrap-script') as HTMLScriptElement | null;
        if (!script) {
          script = document.createElement('script');
          script.id = 'genesys-bootstrap-script';
          script.type = 'text/javascript';
          script.charset = 'utf-8';
          script.async = true;
          script.src = 'https://apps.mypurecloud.de/genesys-bootstrap/genesys.min.js';
          script.onload = () => {
            setTimeout(() => {
              if (isMounted) setIsLoading(false);
            }, 1000);
          };
          script.onerror = () => {
            if (isMounted) setIsLoading(false);
          };
          document.head.appendChild(script);
        } else {
          setTimeout(() => {
            if (isMounted) setIsLoading(false);
          }, 800);
        }
      } catch (err) {
        console.warn('Genesys initialization notice:', err);
        if (isMounted) setIsLoading(false);
      }
    };

    initGenesys();

    // Fallback timer to hide loader if Genesys takes too long or is blocked
    const fallbackTimer = setTimeout(() => {
      if (isMounted) {
        setIsLoading(false);
      }
    }, 3000);

    return () => {
      isMounted = false;
      clearTimeout(fallbackTimer);
    };
  }, [lang, t.deploymentId, t.environment]);

  return (
    <main className="main-content" role="main">
      {isLoading && (
        <div className="loading-container" id="loading" role="status" aria-live="polite">
          <div className="loading-spinner" aria-hidden="true"></div>
          <span>{t.loadingText}</span>
        </div>
      )}

      <div className="support-center-wrapper">
        <div id="genesys-support-center"></div>
      </div>
    </main>
  );
};

export default GenesysSupportCenter;
